<template>
  <div class="list-analytics analysis-chart" v-show="mainChartVisible">
    <div class="t-chart">
      <div class="title">메모리 정보</div>
      <w-plot-line-chart ref="dbMemoryChart" :active="active" :visible="mainChartVisible" :rscInfoList="mainRscInfoList" @clickChart="onClickChart" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import isEmpty from 'lodash/isEmpty';
import { performanceChart } from '@/mixins/performance/charts';
import WPlotLineChart from '@/views/performance/node/analysis/components/PlotLineChart';

export default {
  name: 'WDbMemoryAnalysisChart',
  components: { WPlotLineChart },
  mixins: [performanceChart],
  props: {
    chartVisible: Boolean,
  },
  data() {
    return {
      mainRscInfoList: [{ rsctypeId: 'MEMSTAT', rscId: 'DB_BUF_CACHE_HITRATIO', rscKey: '_' }],
    };
  },
  computed: mapGetters(['selectedNode']),
  watch: {
    selectedNode: {
      immediate: true,
      handler(node) {
        if (isEmpty(node)) {
          return;
        }

        const mainRscInfoList = [{ rsctypeId: 'MEMSTAT', rscId: 'DB_BUF_CACHE_HITRATIO', rscKey: '_' }];
        switch (node.obj.objtypeId) {
          case 'ORACLE': {
            mainRscInfoList.push({ rsctypeId: 'OR_MEMSTAT', rscId: 'DB_BUF_CACHE_HITRATIO', rscKey: '_' }, { rsctypeId: 'OR_MEMSTAT', rscId: 'DBOR_SGA_DIC_CACHE_HITRATIO', rscKey: '_' });
            break;
          }
          case 'TIBERO': {
            mainRscInfoList.push({ rsctypeId: 'TB_MEMSTAT', rscId: 'DBTB_SGA_LIB_CACHE_HITRATIO', rscKey: '_' }, { rsctypeId: 'TB_MEMSTAT', rscId: 'DBTB_SGA_DIC_CACHE_HITRATIO', rscKey: '_' });
            break;
          }
          case 'MSSQL': {
            mainRscInfoList.push({ rsctypeId: 'MS_MEMSTAT', rscId: 'DBMS_PROCEDURE_CACHE_HITRATIO', rscKey: '_' }, { rsctypeId: 'MS_MEMSTAT', rscId: 'DBMS_LOG_CACHE_HITRATIO', rscKey: '_' });
            break;
          }
          case 'MYSQL': {
            mainRscInfoList.push({ rsctypeId: 'MY_MEMSTAT', rscId: 'DBMY_THREAD_CACHE_HITRATIO', rscKey: '_' });
            break;
          }
          case 'ALTIBASE': {
            mainRscInfoList.push({ rsctypeId: 'AT_MEMSTAT', rscId: 'DBAT_BUF_PAGE_HITRATIO', rscKey: '_' });
            break;
          }
          case 'DB2': {
            mainRscInfoList.push(
              { rsctypeId: 'DB2_MEMSTAT', rscId: 'DBDB2_BUF_POOL_DATA_HITRATIO', rscKey: '_' },
              { rsctypeId: 'DB2_MEMSTAT', rscId: 'DBDB2_BUF_POOL_IDX_HITRATIO', rscKey: '_' },
              { rsctypeId: 'DB2_MEMSTAT', rscId: 'DBDB2_XDA_HIT_RATIO', rscKey: '_' },
              { rsctypeId: 'DB2_MEMSTAT', rscId: 'DBDB2_PKG_HITRATIO', rscKey: '_' },
              { rsctypeId: 'DB2_MEMSTAT', rscId: 'DBDB2_CAT_HITRATIO', rscKey: '_' },
            );
            break;
          }
          case 'INFORMIX': {
            mainRscInfoList.push({ rsctypeId: 'IN_MEMSTAT', rscId: 'DBIN_READ_CACHE_HITRATIO', rscKey: '_' }, { rsctypeId: 'IN_MEMSTAT', rscId: 'DBIN_WRITE_CACHE_HITRATIO', rscKey: '_' });
            break;
          }
          case 'SYBASE': {
            mainRscInfoList.push({ rsctypeId: 'SY_MEMSTAT', rscId: 'DBSY_PROCEDURE_CACHE_HITRATIO', rscKey: '_' });
            break;
          }
          default:
            break;
        }
        this.mainRscInfoList = mainRscInfoList;
      },
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/database/components/chart/DbMemoryAnalysisChart.vue